import { render, staticRenderFns } from "./VCardFormAnam.vue?vue&type=template&id=0887b37d"
import script from "./VCardFormAnam.vue?vue&type=script&lang=js"
export * from "./VCardFormAnam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports